const submotivos = [
  { id: 243, id_motivo: 30, submotivo: "HABERES ADMINISTRATIVO 1RA QUINCENA" },
  { id: 54, id_motivo: 30, submotivo: "HABERES ADMINISTRATIVOS 2DA QUINCENA" },
  { id: 55, id_motivo: 30, submotivo: "HABERES FLOTA 2DA QUINCENA" },
  { id: 95, id_motivo: 30, submotivo: "HABERES VIGILANCIA 1ERA QUINCENA" },
  { id: 132, id_motivo: 3, submotivo: "HABERES CONDUCTOR 1ERA QUINCENA" },
  { id: 133, id_motivo: 3, submotivo: "HABERES CONDUCTOR 2DA QUINCENA" },
  { id: 145, id_motivo: 30, submotivo: "HABERES VIGILANCIA 2DA QUINCENA" },
  { id: 146, id_motivo: 30, submotivo: "HABERES MANTENIMIENTO 1ERA QUINCENA" },
  { id: 147, id_motivo: 30, submotivo: "HABERES MANTENIMIENTO 2DA QUINCENA" },
  { id: 238, id_motivo: 30, submotivo: "HABERES FLOTA 1ERA QUINCENA" },
  { id: 245, id_motivo: 3, submotivo: "ADELANTO DE BONO" },
  { id: 123, id_motivo: 3, submotivo: "BONOS" },
  { id: 36, id_motivo: 3, submotivo: "CTS" },
  { id: 153, id_motivo: 30, submotivo: "CTS" },
  { id: 38, id_motivo: 3, submotivo: "GRATIFICACION" },
  { id: 180, id_motivo: 30, submotivo: "GRATIFICACION" },
  { id: 151, id_motivo: 30, submotivo: "BONOS" },
  { id: 246, id_motivo: 3, submotivo: "COMPRAS DIAS LIBRES" },
];

const motivos = [
  { id: 3, nombre: "CF-CARGA PERSONAL" },
  { id: 30, nombre: "GA-HABERES" },
];

// --- FUNCIONES BASE ---
function motivoCajaPlanilla(id) {
  const motivo = motivos.find((m) => m.id === id);
  return motivo ? motivo.nombre : "Desconocido";
}

function submotivoCajaPlanilla(id) {
  const sub = submotivos.find((s) => s.id === id);
  if (!sub) return "Desconocido";

  if (sub.id === 246) {
    return "COMPRAS DIAS LIBRES";
  }

  if (sub.id === 123 || sub.id === 151) {
    return "BONOS";
  }

  if (sub.id === 36 || sub.id === 153) {
    return "CTS";
  }

  if (sub.id === 38 || sub.id === 180) {
    return "GRATIFICACION";
  }

  const motivo = motivos.find((m) => m.id === sub.id_motivo);
  return motivo ? `${motivo.nombre} - ${sub.submotivo}` : sub.submotivo;
}

// --- REGISTRO GLOBAL COMO FILTROS ---
export default function (Vue) {
  Vue.filter("motivoCajaPlanilla", (id) => motivoCajaPlanilla(id));
  Vue.filter("submotivoCajaPlanilla", (id) => submotivoCajaPlanilla(id));
}

// --- Exporta también para uso directo en scripts ---
export { motivoCajaPlanilla, submotivoCajaPlanilla };
